import { Button as BaseButton, type ButtonProps } from '@payaca/ambrosia';
import { FC, PropsWithChildren } from 'react';

export const Banner: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="typography:prose bg-gradient-to-r from-purple-600 to-blue-400">
      <div className="mx-auto max-w-[150rem] px-4 py-4 sm:px-6 lg:px-8">
        {children}
      </div>
    </div>
  );
};

export const Button: FC<Omit<ButtonProps, 'colour'>> = (buttonProps) => {
  return (
    <BaseButton
      {...buttonProps}
      variant={buttonProps.variant || 'outline'}
      colour={'white'}
      size={buttonProps.size || 'sm'}
    />
  );
};

export const AnnouncementBanner = Object.assign(Banner, {
  Button,
});
